import { Component } from '@angular/core';
import { ComTauxComponent } from '@kv-common-components/kv-common-components';

@Component({
    selector: 'app-taux-component',
    templateUrl: './taux.component.html',
    styleUrls: ['./taux.component.css'],
})
export class TauxComponent extends ComTauxComponent {
    constructor() {
        super();
    }
}
